<template>
  <div class="c_button__close" @click="tapAction">
    <img class="c_img" src="../assets/img/buttons/close@3x.png" />
  </div>
</template>

<script>
export default {
  name: 'UICloseButton',
  methods: {
    tapAction () {
      this.$emit('click')
    }
  }
}
</script>

<style scoped>

.c_button__close {
  background-color: #ffffff;
  border: none;
  width: 100%;
  height: 100%;
  border-radius: 50%;
  display:flex;
  align-items: center;
  justify-content: center;
}

.c_img {
  width: 30px;
  vertical-align: middle;
}

</style>
